import axios from "axios";

const { REACT_APP_API_URL } = process.env;

export const LOGIN_URL = `${REACT_APP_API_URL}auth/login`;
export const LOGOUT_URL = `${REACT_APP_API_URL}auth/logout`;

export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";

export const ME_URL = `${REACT_APP_API_URL}auth/profile`;

export function login(username, password) {
  return axios.post(LOGIN_URL, { username, password });
}

export function logout(token) {
  return axios.post(LOGOUT_URL, null, {
    headers: { Authorization: `bearer ${token}` },
  });

}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}
